export const translations = {
  tr: {
    nav: {
      about:    "Hakkımda",
      projects: "Projeler",
      stack:    "Teknoloji",
      contact:  "İletişim",
      cta:      "İletişime Geç",
    },
    hero: {
      badge:        "Full Stack Developer · Web · Mobile · AI",
      desc:         "Hayal gücüyle kodu birleştiriyorum. Modern, animasyonlu ve geleceğe dönük web deneyimleri yaratıyorum.",
      viewProjects: "Projeleri Gör",
      getInTouch:   "İletişime Geç",
      scroll:       "Kaydır",
    },
    about: {
      heading:    "Hakkımda",
      p1:         "Web, mobil ve yapay zekâ odaklı projeler geliştiren bir Full Stack Developer'ım. Bilgisayar mühendisliği altyapımı; modern frontend teknolojileri, backend geliştirme, bulut servisleri ve kullanıcı deneyimi tasarımıyla birleştirerek uçtan uca çalışan dijital ürünler üretmeye odaklanıyorum.",
      p2:         "React.js, TypeScript, Python, Flutter, Firebase ve AWS gibi teknolojilerle hem kullanıcı arayüzü güçlü hem de ölçeklenebilir yapıya sahip uygulamalar geliştiriyorum. Projelerimde yalnızca çalışan kod yazmayı değil, aynı zamanda temiz mimari, sürdürülebilir yapı, performans ve gerçek kullanıcı ihtiyacını merkeze alan çözümler üretmeyi önemsiyorum.",
      p3:         "Hedefim; teknik olarak güçlü, görsel olarak modern ve gerçek hayatta değer üreten ürünler geliştirmek. Her projeyi benim için yeni bir laboratuvar gibi görüyorum: fikirleri kodla şekillendirdiğim, hatalardan öğrendiğim ve daha iyi çözümler inşa ettiğim bir alan.",
      techLabel:  "Teknolojiler",
      cta:        "İletişime Geç",
      yearsExp:   "Yıl Deneyim",
      projects:   "Tamamlanan Proje",
    },
    projects: {
      heading:     "Projeler",
      subheading:  "Modern teknolojilerle hayata geçirdiğim çalışmalar.",
      allLabel:    "Tümü",
      viewDetails: "Detayları Gör",
      empty:       "Bu kategoride henüz proje bulunmuyor.",
      techLabel:   "Teknolojiler",
      liveDemo:    "Canlı Demo",
      github:      "GitHub",
    },
    stack: {
      heading:  "Teknolojiler",
      database: "Veritabanı",
    },
    achievements: {
      heading: "Rakamlar",
      stats: [
        { label: "Tamamlanan Proje",    desc: "Başarıyla teslim edildi"  },
        { label: "Yıl Deneyim",         desc: "Sektörde aktif çalışma"   },
        { label: "Mutlu Müşteri",       desc: "Uzun dönem iş birlikleri" },
        { label: "Müşteri Memnuniyeti", desc: "Ortalama proje puanı"     },
      ],
    },
    testimonials: {
      heading: "Referanslar",
      items: [
        { name: "Elif K.",   title: "Startup Founder",         content: "Gerçekten hızlı ve modern bir site teslim aldık. Her detay özenliydi. Teşekkürler!" },
        { name: "Ahmet B.",  title: "Freelancer",               content: "Portfolyo şablonu çok şık ve etkileyici, müşterilerimden güzel dönüşler aldım." },
        { name: "Zeynep Y.", title: "Ajans Yöneticisi",         content: "Birebir istediğim gibi, hatta daha fazlası oldu. Proje yönetimi ve iletişim de çok iyiydi." },
        { name: "Murat D.",  title: "E-ticaret Müdürü",         content: "E-ticaret sitemiz için yaptığı çalışma mükemmeldi. Performans ve kullanıcı deneyimi harika!" },
        { name: "Selin A.",  title: "Kurumsal Müşteri",         content: "Responsive tasarım ve animasyonlar çok etkileyici. Müşterilerim sürekli sitemi övüyor." },
        { name: "Emre T.",   title: "Yazılım Müdürü",           content: "API entegrasyonu ve backend geliştirme konusunda gerçekten uzman. Zamanında teslim aldık." },
        { name: "Ayşe M.",   title: "Dijital Pazarlama Uzmanı", content: "Mobil uyumlu ve hızlı çalışan bir platform geliştirdi. Sonuçlardan çok memnunuz." },
        { name: "Can O.",    title: "Proje Yöneticisi",         content: "Modern teknolojiler kullanarak hayal ettiğimiz projeyi hayata geçirdi. Profesyonel yaklaşım!" },
        { name: "Ali D.",    title: "Şirket Sahibi",            content: "Güzel iş ahlakı ve anlayış. Hızlı geri dönüş ve pratik iş ortaklığın için teşekkürler." },
      ],
    },
    contact: {
      heading:          "İletişim",
      subheading:       "Proje fikrinizi konuşalım. 24 saat içinde dönüş yaparım.",
      emailLabel:       "E-posta",
      linkedinLabel:    "LinkedIn",
      githubLabel:      "GitHub",
      locationLabel:    "Konum",
      location:         "İstanbul, Türkiye",
      available:        "Projeye açığım",
      availableDesc:    "Yeni freelance projeler ve iş birlikleri için müsaitim.",
      nameLabel:        "İsim Soyisim *",
      namePlaceholder:  "Adınız Soyadınız",
      emailFieldLabel:  "E-posta *",
      emailPlaceholder: "ornek@email.com",
      messageLabel:     "Mesaj *",
      msgPlaceholder:   "Projeniz hakkında kısaca bilgi verin...",
      send:             "Mesaj Gönder",
      sending:          "Gönderiliyor...",
      sentTitle:        "Mesaj Gönderildi",
      sentDesc:         "En kısa sürede dönüş yapacağım.",
      newMessage:       "Yeni Mesaj",
      errorTitle:       "Gönderilemedi",
      errorDesc:        "Bir şeyler ters gitti. Lütfen tekrar deneyin ya da doğrudan e-posta gönderin.",
      retry:            "Tekrar Dene",
      formSubject:      "Portfolio İletişim Formu",
    },
    jelly: {
      label:       "— interaktif —",
      title:       "Biraz Eğlen.",
      subtitle:    "Sıkıştır, sonra bana yaz.",
      followMouse: "Fareyi takip et",
    },
    footer: {
      desc:   "Modern, performanslı ve estetik web uygulamaları geliştiren Frontend Developer.",
      rights: "Tüm hakları saklıdır.",
      nav: {
        about:    "Hakkımda",
        projects: "Projeler",
        stack:    "Teknoloji",
        contact:  "İletişim",
      },
    },
  },

  en: {
    nav: {
      about:    "About",
      projects: "Projects",
      stack:    "Tech Stack",
      contact:  "Contact",
      cta:      "Get in Touch",
    },
    hero: {
      badge:        "Full Stack Developer · Web · Mobile · AI",
      desc:         "Combining imagination with code. Building modern, animated, and future-forward web experiences.",
      viewProjects: "View Projects",
      getInTouch:   "Get in Touch",
      scroll:       "Scroll",
    },
    about: {
      heading:    "About Me",
      p1:         "I'm a Full Stack Developer building web, mobile, and AI-driven projects. I combine my computer engineering background with modern frontend technologies, backend development, cloud services, and UX design to create end-to-end digital products.",
      p2:         "Using React.js, TypeScript, Python, Flutter, Firebase, and AWS, I develop applications with strong user interfaces and scalable architectures. Beyond writing working code, I focus on clean architecture, sustainable structure, performance, and solutions centered on real user needs.",
      p3:         "My goal is to build products that are technically solid, visually modern, and create real-world value. I treat every project as a new lab — a space where I shape ideas with code, learn from mistakes, and build better solutions.",
      techLabel:  "Technologies",
      cta:        "Get in Touch",
      yearsExp:   "Years Experience",
      projects:   "Completed Projects",
    },
    projects: {
      heading:     "Projects",
      subheading:  "Work brought to life with modern technologies.",
      allLabel:    "All",
      viewDetails: "View Details",
      empty:       "No projects in this category yet.",
      techLabel:   "Technologies",
      liveDemo:    "Live Demo",
      github:      "GitHub",
    },
    stack: {
      heading:  "Tech Stack",
      database: "Database",
    },
    achievements: {
      heading: "Numbers",
      stats: [
        { label: "Completed Projects",  desc: "Successfully delivered"  },
        { label: "Years Experience",    desc: "Active in the industry"  },
        { label: "Happy Clients",       desc: "Long-term partnerships"  },
        { label: "Client Satisfaction", desc: "Average project rating"  },
      ],
    },
    testimonials: {
      heading: "Testimonials",
      items: [
        { name: "Elif K.",   title: "Startup Founder",              content: "We received a truly fast and modern site. Every detail was crafted with care. Thank you!" },
        { name: "Ahmet B.",  title: "Freelancer",                    content: "The portfolio template is very stylish and impressive — I've received great feedback from my clients." },
        { name: "Zeynep Y.", title: "Agency Manager",                content: "Exactly as I wanted, and even more. Project management and communication were excellent." },
        { name: "Murat D.",  title: "E-commerce Manager",            content: "The work done for our e-commerce site was excellent. Performance and user experience are amazing!" },
        { name: "Selin A.",  title: "Corporate Client",              content: "The responsive design and animations are very impressive. My clients always compliment the site." },
        { name: "Emre T.",   title: "Software Manager",              content: "A true expert in API integration and backend development. Delivery was right on time." },
        { name: "Ayşe M.",   title: "Digital Marketing Specialist",  content: "Developed a mobile-friendly, fast-running platform. We are very pleased with the results." },
        { name: "Can O.",    title: "Project Manager",               content: "Brought our dream project to life using modern technologies. Very professional approach!" },
        { name: "Ali D.",    title: "Business Owner",                content: "Great work ethic and understanding. Thanks for the quick responses and practical partnership." },
      ],
    },
    contact: {
      heading:          "Contact",
      subheading:       "Let's talk about your project idea. I'll get back to you within 24 hours.",
      emailLabel:       "Email",
      linkedinLabel:    "LinkedIn",
      githubLabel:      "GitHub",
      locationLabel:    "Location",
      location:         "Istanbul, Turkey",
      available:        "Available for projects",
      availableDesc:    "Open to new freelance projects and collaborations.",
      nameLabel:        "Full Name *",
      namePlaceholder:  "Your Full Name",
      emailFieldLabel:  "Email *",
      emailPlaceholder: "example@email.com",
      messageLabel:     "Message *",
      msgPlaceholder:   "Tell me briefly about your project...",
      send:             "Send Message",
      sending:          "Sending...",
      sentTitle:        "Message Sent",
      sentDesc:         "I'll get back to you as soon as possible.",
      newMessage:       "New Message",
      errorTitle:       "Couldn't Send",
      errorDesc:        "Something went wrong. Please try again or email me directly.",
      retry:            "Try Again",
      formSubject:      "Portfolio Contact Form",
    },
    jelly: {
      label:       "— interactive —",
      title:       "Have Some Fun.",
      subtitle:    "Squeeze it, then write to me.",
      followMouse: "Follow mouse",
    },
    footer: {
      desc:   "Frontend Developer crafting modern, performant, and aesthetic web applications.",
      rights: "All rights reserved.",
      nav: {
        about:    "About",
        projects: "Projects",
        stack:    "Tech Stack",
        contact:  "Contact",
      },
    },
  },
};

export type Lang         = "tr" | "en";
export type Translations = typeof translations["tr"];
